import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { demo } from 'page/catalog/store/CatalogStore'
import css from './SalarisButton.module.scss'

export const FooButton = observer(() => {
  const { background } = demo.it.welcome ?? {}

  const onClick = useLatestCallback(() => {
    demo.it.startBasic()
  })

  return <Space className={css.button} style={{ background: background }} gap={16} center onClick={onClick}>
    <Typo size={32} upper one semi center>
      {i18n('TryOnKit')}
    </Typo>
  </Space>
})
